import { AgentApiPath, useHallApi } from '@99fun-agent/hooks'
import { defineStore } from 'pinia'

export const useRuleStore = defineStore('ruleStore', () => {
  const { authGet } = useHallApi()
  const reqGetRules = async () => {
    const r = await authGet<IGetRulesReply>(
      AgentApiPath.GetRules,
      {},
      {
        showErrorCodeTip: true,
        showLoading: true
      }
    )

    return r.data
  }
  const reset = () => {}
  return { reset, reqGetRules }
})

export interface IGetRulesReply {
  ranges: IRuleRange[]
}

export interface IRuleRange {
  minNetEarningAmount: number
  maxNetEarningAmount: number
  minActiveUsersCount: number
  maxActiveUsersCount: number
  dividendRatio: number
}
